import * as React from 'react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { RoleEditorController } from 'src/app/general/roles/list/parts/role-editor.controller';

interface RoleUserEditorViewProps extends ComponentViewProps<DataSet<UserRoleSummary>> {
	onItemDoubleClicked?: (item: UserRoleSummary) => void;
	createNewUserRole: (roleId: number) => Promise<UserRoleSummary>;
	onCancel: () => Promise<any>;
	mode: ControlMode;
}

export class RoleUserEditorView extends React.Component<RoleUserEditorViewProps, {}> {
	constructor(props: Readonly<RoleUserEditorViewProps>) {
		super(props);
	}

	rowKey = (record: UserRoleSummary): string => record.id.toString();

	render(): JSX.Element {
		const { model } = this.props;
		const filteredRoles = model.items.map(m => m.roleId);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Role',
				dataIndex: 'displayName',
				editable: (text: string, record: UserRoleSummary, index: number, isSelected: boolean) =>
					isSelected
						? (
							<RoleEditorController
								required
								label={null}
								mode="edit"
								setBusy={this.props.setBusy}
								value={record.roleId}
								roleList={filteredRoles}
								onChanged={(item) => {
									record.roleId = item.id;
									record.displayName = item.displayName;
								}}
							/>
						)
						: record.displayName || ""
			}
		];

		return (
			<DataTableView
				model={model}
				mode={this.props.mode}
				columns={columns}
				rowKey={this.rowKey}
				hideToolbar={ToolbarVisibility.hideSearch}
				setBusy={this.props.setBusy}
				onCancel={this.props.onCancel}
				createNewItem={() => {
					return this.props.createNewUserRole(-1);
				}}
				itemDoubleClick={(item) => {
					if (this.props.onItemDoubleClicked) {
						this.props.onItemDoubleClicked(item);
					}
				}}
			/>

		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/roles/parts/role-user-editor.view.tsx